import { render, staticRenderFns } from "./DLevelEditor.vue?vue&type=template&id=49e20027&"
import script from "./DLevelEditor.vue?vue&type=script&lang=js&"
export * from "./DLevelEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports